/**
 * Aufzählungen der Authentisierung
 */
export enum jwtokenState {
    granted = "Access granted.",
    denied = "Access denied."   
}